import { render, staticRenderFns } from "./PWProductAdd.vue?vue&type=template&id=d1eaed10&"
import script from "./PWProductAdd.vue?vue&type=script&lang=js&"
export * from "./PWProductAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports